module.exports = __webpack_public_path__ + "static/media/icon-piggy-bank-default.5b75805f.svg";